<template>
<div class="shopMobSearch">
    <div class="searchCase">
        <img src="../../../../../common/images/shop/search-icon.png" alt="">
        <span>搜索内容名称</span>
    </div>
</div>
</template>

<script>
export default {
    name: 'shopMobSearch',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.shopMobSearch {
    width: 15rem;
    box-sizing: border-box;
    padding: 0.36rem 0.64rem;
    .searchCase{
        width: 100%;
        height: 1.2rem;
        background: #F5F7FA;
        text-align: center;
        line-height: 1.2rem;
        font-size: 0.56rem;
        img{
            width: 0.56rem;
            height: 0.56rem;
            margin-right: 0.1rem;
            position: relative;
            top: 2px;
        }
        span{
            color: #C0C4CC;
        }
    }
}
</style>
